import React from "react";
import { Message } from "components/Atoms/Message";

interface Props {
  classNames?: string;
}

export const SomethingUnexpectedHappenedMessageBox = (props: Props) => {
  return (
    <Message type="error" className={props.classNames}>
      {RESX.GeneralLabels.SomethingUnexpectedHappened}
    </Message>
  );
};
